import { getCookie } from '../utils/cookieNew'

const state = {
  namespaced: true,
  isLoading: false,
  refCount: 0,
  encData: '',
  scarInfoData: [],
  failIdentity: false,
  version: {
    check: false,
    os: '',
    version: '',
    option: '',
    url: ''
  },
  userData: {
    userName: getCookie('userName') || '',
    token: getCookie('token') || '',
    id: getCookie('userId') || '',
    tokenPeriod: '30m',
    checkedPw: false,
    birthData: '',
    mail: '',
    tel: ''
  },
  temporaryData: {
    userName: '',
    gender: '',
    birthDate: '',
    userNameFlag: '',
    genderFlag: '',
    birthDateFlag: ''
  },
  userInfo: {
    list: []
  },
  param: {
    resvCode: ''
  },
  coming: {
    comingReasonCategory: '',
    comingReasonCode: '',
    comingReasonContent: '',
    visitPathCode: '',
    etc: '',
    etcReason: '',
    etcContents: '',
    list: [],
    content: ''
  },
  comingTell: {
    userName: '',
    tel: '',
    requestContents: '',
    comingReasonCategory: '',
    comingReasonCode: '',
    comingReasonContent: '',
    visitPathCode: '',
    etc: '',
    etcReason: '',
    etcContents: '',
    content: ''
  },
  preReservation: {
    comingReasonCategory: '',
    comingReasonCode: '',
    visitPathCode: '',
    etc: '',
    etcReason: '',
    doctorCode: '',
    doctorName: '',
    doctorImg: ''
  },
  visit: {
    list: []
  },
  calendarList: {
    list: [],
    targetDate: ''
  },
  telDataCarry: {
    userName: '',
    tel: '',
    requestContents: '',
    visitPathCode: '',
    checkAgreements: false
  },
  doctorInfo: [],
  doctorSchedule: {
  },
  doctorCode: '',
  pushList: {
    result: false,
    list: [],
    check: false,
    count: ''
  },
  device: {
    pushKey: getCookie('pushKey') || '',
    deviceId: getCookie('deviceId') || '',
    appVersion: getCookie('appVersion') || '',
    device: getCookie('device') || ''
  },
  surgery: {
    surgeryList: [],
    surgeryDate: [],
    kakaoUrl: ''
  },
  reservationInfo: [],
  reservationList: [],
  reservationListInfo: [],
  reservationItemInfo: [],
  certificateLookupDate: [],
  medicalMonthDate: [],
  surgeryDate: [],
  scarInfoCode: [],
  scarInfoList: [],
  reBookingSet: [],
  surgeryCodeSet: [],
  banner: [],
  bannerDetail: [],
  isCauseAuthError: {
    status: false,
    url: ''
  },
  view: {
    logicPassed: false,
    redirectMainMessage: false,
    autoLoginDone: false,
    isChangePw: false,
    isAddBoard: false,
    isCauseAction: false,
    reservationDone: false,
    reservationUpdateQuit: false,
    reservationUpdateDone: false,
    deleteReservationDone: false,
    scarUploadDone: false,
    reservationInit: false,
    guestCheckAgreement: false,
    isAutoLogin: false,
    surgeryDone: false,
    isLogin: false,
    isSideBarOpen: false,
    refreshAppHeader: false,
    scarUploadEscape: false,
    sidebarAlarm: false,
    pushAble: false,
    authorizeChecked: {
      wholeCheck: false,
      privacyCheck: false,
      termsCheck: false,
      temporaryPrivacyCheck: false,
      temporaryTermsCheck: false
    }
  },
  uploadPreData: [],
  scarUploadList: [],
  scarFetchedImg: [],
  checkPopup: false,
  checkChat: false,
  checkPopupHeader: false,
  checkPopupHeaderMain: false,
  checkPopupSide: false,
  prevUrl: ''
}
export default state
